class DataStore {
    constructor() {
        /* scrolling ++++++++++++++++++++++++++++++++++++++++++*/
        this.docScroll = '';
        this.win = $(window);
        this.body = $('body');

        /* window ++++++++++++++++++++++++++++++++++++++++++*/

        this.docWidth = $(document).width();
        this.docHeight = $(document).height();
        this.winHeight = $(window).height();

        /* header ++++++++++++++++++++++++++++++++++++++++++*/
        this.header = $('#scrollHeader');
        this.scrollnav = $('#scrollNav');
        this.scrollnavOpen = false;

        /* non editable ++++++++++++++++++++++++++++++++++++++++++*/
        this.endOfResize = false;

        /* browser ++++++++++++++++++++++++++++++++++++++++++*/

        this.isIe = false;
        this.isFirefox = false;
        this.isSafari = false;
        this.isNoIe = false;
        this.touch = false;
        this.touchBreakPoint = 768;

        /* ids ++++++++++++++++++++++++++++++++++++++++++*/
        // eslint-disable-next-line
        this.globalIds = JSON.parse(window.wpUrls.globalIds);

        /* fancybox ++++++++++++++++++++++++++++++++++++++++++*/
        this.fancyBoxOnceOpened = false;

        /* masonry ++++++++++++++++++++++++++++++++++++++++++*/
        this.grid = '';
        this.$container = $('.masonry');

        /* lazyload ++++++++++++++++++++++++++++++++++++++++++*/
        this.lazyLoadInstance = '';

        /* Map ++++++++++++++++++++++++++++++++++++++++++*/
        this.mapMarkers = [];
        this.map = '';

        // Products Table
        this.endOfType = false;
        this.nonce = '';
        this.discount = 0;
        this.productsTable = $('#productsTable');
        this.productsTableLength = this.productsTable.length;
        if (this.productsTableLength) {
            this.productsTableHeight = this.productsTable.height();
            this.productsTableOffsetTop = this.productsTable.offset().top;
        }
        this.productsTableTerm = '';
        this.productsTableSearch = '';
        this.productsTableEnd = false;
        this.productsTableIsLoading = false;
        this.productsTableProductHashSlug = '';

        /* youtube video ++++++++++++++++++++++++++++++++++++++++++*/
        this.vidWrap = $('#videoTooltip');
        this.player = false;
        this.vidLink = false;
        this.x = 0;
        this.y = false;
        /* products ++++++++++++++++++++++++++++++++++++++++++*/

        this.isPreorderProduct = false;
        this.hasBackToTop = false;
        this.backToTop = $('#backToTop');
        this.scrollWrap = $('.scrollWrap');
        this.scrollWrapTop = false;
        this.filterBar = $('#filterBar');
        this.filterBarHeight = false;
        this.selectedCats = [];
        this.productsTable = $('#productsTable');
        this.fitlerCats = $('#catFilter li');
        this.watchlistItems = localStorage.getItem('watchListItems');
        this.productsNum = $('.productsNum');
        this.cartItems = localStorage.getItem('cartItems');
        this.cartProductsNum = $('.cartProductsNum');
        this.ajaxActive = false;
        this.hoverOnVid = false;
        this.isB2B = false;
        this.infowindows = [];
        this.templateStore = [];
        this.output = [];
        this.outputIndex = 0;
        this.endOfappend = false;
        this.gutschein_type = '';

        this.wpcf7response = $('.wpcf7-response-output');

        this.stickyWrap = $('#stickyWrap');

        /* Product list Location ++++++++++++++++++++++++++++++++++++++++++*/
        this.productListLocation = false;
        this.singleProducts = false;

        if ($('.single-products').length) {
            this.productListLocation = 'singleProduct';
            this.singleProducts = true;
        } else if (parseInt(window.wp_urls.pageID, 10) === this.globalIds.b2bCart) {
            this.productListLocation = 'b2bCart';
        } else if (parseInt(window.wp_urls.pageID, 10) === this.globalIds.watchList) {
            this.productListLocation = 'watchList';
        } else if ($('.post-type-archive-products')) {
            this.productListLocation = 'productsArchive';
        }

        this.hasAnim = false;
        this.anim = false;
        this.animDuration = 2000;

        /* Parapllax ++++++++++++++++++++++++++++++++++++++++++*/
        this.parallaxWrap = $('[data-parallaxWrap]');
        this.parallaxItem = this.parallaxWrap.length;
        this.parallaxObject = [];
        this.allowScroll = true;
    }
}

export default (new DataStore());
